export default __webpack_public_path__ + "static/logo6-03f48e3e60159b5132996c87f5822eb2.png";